import { FormControl } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Controller, useFormContext } from 'react-hook-form';

dayjs.extend(utc);
dayjs.extend(timezone);

interface InputTimeProps {
  name: string;
  label?: string;
  saveAsString?: boolean;
}
export const InputTime = ({ name, label, saveAsString = false }: InputTimeProps) => {
  const { control } = useFormContext() || {};
  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          let displayValue: dayjs.Dayjs | null = null;
          if (value) {
            if (typeof value === 'string' && /^\d{1,2}:\d{2}$/.test(value)) {
              const [hours, minutes] = value.split(':');
              displayValue = dayjs().hour(parseInt(hours, 10)).minute(parseInt(minutes, 10)).second(0).millisecond(0);
            } else if (dayjs.isDayjs(value)) {
              displayValue = value;
            } else {
              const parsed = dayjs.tz(value, 'Asia/Jerusalem');
              displayValue = parsed.isValid() ? parsed : null;
            }
          }

          return (
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="he">
              <TimePicker
                value={displayValue}
                onChange={(event: dayjs.Dayjs | null) => {
                  if (saveAsString) {
                    if (event && dayjs.isDayjs(event) && event.isValid()) {
                      const hours = event.hour();
                      const minutes = event.minute();
                      const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                      onChange(timeString);
                    } else {
                      onChange('');
                    }
                  } else {
                    onChange(event);
                  }
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock
                }}
                label={label}
                ampm={false}
                slotProps={{
                  textField: {
                    size: 'small',
                    fullWidth: true,
                    error: !!error,
                    helperText: error?.message,
                    onKeyDown: e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }
                  }
                }}
              />
            </LocalizationProvider>
          );
        }}
      />
    </FormControl>
  );
};

export default InputTime;
